<ng-container *ngIf="renderAsMenuOption === true">
  <button
    class="btn p-0 nav-link position-relative"
    title="Support"
    data-bs-toggle="collapse"
    data-bs-target=".navbar-collapse.show"
    (click)="openSupportDialog()">
    <span class="material-icons align-middle d-inline d-lg-none d-xl-inline">contact_support</span
    ><span class="align-middle ms-1">Supportfråga</span>
  </button>
</ng-container>
<ng-container *ngIf="renderAsMenuOption === false">
  <button (click)="openSupportDialog()" class="btn p-0" title="Support">
    <span class="material-icons text-light align-middle">contact_support</span>
  </button>
</ng-container>
